export default class {
  // 这里需要配合keep-alive的includeAPI，设置vuex的缓存list，以实现tab关闭后vue不缓存该页面
  // 加载tabs缓存
  loadTabs() {
    const pageTabs = sessionStorage.getItem('page-tabs');
    if (pageTabs) {
      this.tabs = JSON.parse(pageTabs);
    }
    this.$store.commit('setKeepAliveList',this.tabs.map(i=>i.route));
  }

  // tab切换更新
  updateTabs() {
    const route = this.$route.name;
    const title = this.$expressway.findTitleByRouteName(route) || route;
    if(!route || route === 'index'){
      // 这里是处理layout中第一次加载会是null，后续由监听$route更新，(index路由是引导用的，不需要)
      // 而如果是当从没有tabs的页面跳转过来时，不走下面，将不会变更当前激活
      return;
    }
    // 新增
    if (!this.tabs.find(i => i.route === route)) {
      this.tabs.push({ route, title });
    }
    this.activeRoute = route;
    // this.$route.meta.keepAlive = true;
    // 缓存tabs
    sessionStorage.setItem('page-tabs', JSON.stringify(this.tabs));
    this.$store.commit('setKeepAliveList',this.tabs.map(i=>i.route));
  }

  // 移除tab
  removeTab(route) {
    // 保存index
    let index = this.tabs.findIndex(i => i.route === route);
    this.tabs = this.tabs.filter(i => i.route !== route);
    this.$store.commit('setKeepAliveList',this.tabs.map(i=>i.route));
    // 如果删除的是当前的route
    if (this.activeRoute === route) {
      // 将当前激活route切换为刚才删除的后一个
      if (index > this.tabs.length-1 ) {
        index -= 1 ;
      }
      this.activeRoute = this.tabs[index].route;
      // this.$route.meta.keepAlive = false;
      this.$router.push({ name: this.activeRoute });
    }
    // 缓存tabs
    sessionStorage.setItem('page-tabs', JSON.stringify(this.tabs));
  }

  // 检查是否可以继续删除
  checkClosable() {
    this.closable = this.tabs.length > 1;
  }

}
